<template>
  <nav>
    <div class="left-nav">
      <sprite-button class="backButton"
      @click="back"
      background-url="/img/back_button.png"
      width="78px"
      height="50px"
      >Back</sprite-button>
    </div>
    
    <div class="middle-nav">
      <slot></slot>
    </div>
    
    <div class="right-nav">
      <sprite-button class="homeButton"
      href="#/"
      background-url="/img/home_button.png"
      width="56px"
      height="50px"
      >Home</sprite-button>
    </div>
  </nav>
</template>

<script>
export default {
  methods: {
    back () {
      window.history.back()
    }
  }
}
</script>

<style lang="less">
nav {
  background-color: #20262e;
  height: 54px;
  width: 100%;
  display: flex;
  .middle-nav {
    flex: 1;
    color: #afd2ef;
    font-size: 1.2em;
    text-align: center;
    line-height: 54px;
    margin-top: 0;
    padding-top: 0;
    
  }
}
</style>